import request from '@/services/axios'

/** 后端导出 PPTX（output: url 返回下载链接，stream 返回文件流） */
export const exportPptx = (data: { params: { id: string; output: 'url' | 'stream'; options?: Record<string, boolean> } }) => {
  return request.post('/api/exports/export/pptx', data)
}

/** 后端导出 PPTX 文件流 */
export const exportPptxStream = (data: { params: { id: string; output: 'stream'; options?: Record<string, boolean> } }) => {
  return request.fileDownload('/api/exports/export/pptx', data)
}
